<template v-slot:append>
  <v-dialog max-width="95%" persistent no-click-animation
      v-bind="computedProps"
      v-on="computedListeners"
      v-model="showDialog">
    <v-card min-height="75%" min-width="95%">
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer/>
        <v-toolbar-title>
          日報検索
        </v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-expansion-panels v-model="expansionPanel" multiple flat>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-row ref="_calcHeight-Row1">
                  <v-col :cols="12">
                    <dd-sub-header>
                      検索条件
                    </dd-sub-header>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row no-gutters align-content="center">
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <div style="width:48%" class="px-1">
                        <dd-date-box
                          label="日報日"
                          v-model="conditions.nippoYmdFrom"
                          ref="nippoYmdFrom"
                          :readonly="false"
                          />
                      </div>
                      <div style="width:4%" class="mt-2 mp-0">～</div>
                      <div style="width:48%" class="px-1">
                        <dd-date-box
                          v-model="conditions.nippoYmdTo"
                          ref="nippoYmdTo"
                          :readonly="false"
                          />
                      </div>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="営業所コード/名称"
                          v-model="conditions.Eigyosho"
                          ref="sagyoEigyoshoCd"
                          :required=false
                          :length=100
                          :valueType="ctypes.InputTypes.Free"
                          :itemList="filteredEigyoshoList"
                          titleText="営業所検索"
                          item-value="eigyoshoCd"
                          item-text="eigyoshoNm"
                          :headerList="eigyoshoHeader"
                          />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <v-radio-group
                          label="日報種別"
                          v-model="conditions.nippoSbt"
                          @change="onChangeNippoSbt"
                          row>
                          <dd-radio-button
                            style="width:18%"
                            label="全て"
                            value="99"
                          />
                          <dd-radio-button
                            style="width:18%"
                            label="自社"
                            value="01"
                          />
                          <dd-radio-button
                            style="width:18%"
                            label="傭車"
                            value="03"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols=3>
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-checkbox
                          label="貨物に紐付けされていないもののみ対象とする"
                          v-model="conditions.kamotsuTaishoFlg"
                          ref="kamotsuTaishoFlg"
                          />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row no-gutters align-content="center">
                  <v-col :cols="3">
                  <v-row no-gutters align-content="center">
                      <v-col class="px-1">
                        <dd-code-text-box
                          label="乗務員コード/氏名"
                          :required=false
                          v-model="conditions.jomuin"
                          ref="jomuin"
                          :length=100
                          :valueType="ctypes.InputTypes.Free"
                          :itemList="filteredJininList"
                          titleText="乗務員検索"
                          item-value="jininCd"
                          item-text="jininNm"
                          :headerList="jininHeader"
                          />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="車両番号/ナンバープレート"
                          v-model="conditions.sharyo"
                          ref="sharyoCd"
                          :length="100"
                          :required="false"
                          :valueType="Ctrls.InputTypes.Alphanumeric"
                          titleText="車両検索"
                          :headerList="syaryoHeader"
                          item-value="sharyoCd"
                          item-text="torokuNo"
                          returnValueName="id"
                          :itemList="filteredMstSharyoList"
                          />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="取引先コード/名称"
                          :required=false
                          v-model="conditions.tokuisakiCd"
                          ref="tokuisakiCd"
                          :length=100
                          :valueType="ctypes.InputTypes.Free"
                          :itemList="filteredTorihikisakiList"
                          titleText="取引先検索"
                          item-value="torihikisakiCd"
                          item-text="torihikisakiNm"
                          :headerList="torihikisakiHeader"
                          />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-toolbar class="pa-0 ma-0" flat dense>
                        <v-spacer />
                        <dd-default-button
                          class="ml-2"
                          dark
                          dense
                          @click="onSearchButtonClick">
                          検索
                        </dd-default-button>
                        <dd-default-button
                          class="ml-2"
                          dark
                          dense
                          @click="onClearButtonClick">
                          クリア
                        </dd-default-button>
                      </v-toolbar>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-row no-gutters align-content="center">
            <v-col :cols="6">
              <dd-sub-header>
                一覧
              </dd-sub-header>
            </v-col>
            <v-col :cols="1"></v-col>
            <v-col :cols="3">
              <dd-narrow-down-text-box v-model="searchText" :length=10 />
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                label="検索結果"
                v-model="rowCount"/>
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                label="絞込結果"
                v-model="filteredRowCount"/>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center">
            <v-col :cols="12">
              <dd-data-table
                v-model="selectedItem"
                calculate-widths
                :height="calcHeightTable"
                item-key="id"
                showSelect
                singleSelect
                @dblclick:row="onRowDoubleClick"
                @click:row="onRowClick"
                :headers="headers"
                :items="filteredRows"
                :search="searchText"
                :loading="loading"
                :header-props="{sortByText: '並び替え'}"
                :footer-props="{'items-per-page-options': [100, 200, 300, 400, 500],showFirstLastPage: true,}"
                loading-text="検索中のため、少々お待ちください。"
                :itemsPerPage=500
                fixed-header
                locale="ja-jp"
                no-data-text="利用可能なデータはありません。"
                dense
                :page.sync ="page"
                />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <dd-footer-button
          @click="onCloseClick">
          閉じる
        </dd-footer-button>
        <v-spacer></v-spacer>
        <dd-footer-button
          :disabled="isSelectButtonDisabled"
          @click="onSelectButtonClick">
          選択
        </dd-footer-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import controls from '@/rahmen/controls'
import modals from '@/ddv2.library/modals'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'
import validators from '@/rahmen/validators'
import date from '@/ddv2.library/date'

import { mapGetters } from 'vuex'

const DdSubHeader = () => import('@/components/DdSubHeader')
const DdDateBox = () => import('@/components/DdDateBox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdDataTable = () => import('@/components/DdDataTable')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdCheckbox = () => import('@/components/DdCheckbox')

/*
貨物入力用の日報検索ダイアログ
"貨物に紐付けされていないもののみ対象とする"チェックボックスを削除し、必ず紐づけされていないもののみ対象とする。
*/

export default {
  name: 'ThNippoNoSearchDialogVKamotsu',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdFooterButton,
    DdDateBox,
    DdCodeTextBox,
    DdRadioButton,
    DdDataTable,
    DdRowCountBox,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdCheckbox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * ダイアログタイトル
     */
    titleText: String,
    /**
     * 親画面 積日付
     */
    hatsuchiYmd: String
  },
  data: () => ({
    conditions: {
      nippoYmdFrom: '',
      nippoYmdTo: '',
      Eigyosho: '',
      nippoSbt: '',
      kamotsuTaishoFlg: true,
      jomuin: '',
      sharyo: '',
      tokuisakiCd: ''
    },
    searchText: '',
    ctypes: controls,
    // 拡張パネル
    expansionPanel: [0, 1],
    /**
     * 一覧内容
     */
    rows: [],
    loading: false,
    selectedItem: [],
    /*
     *
     */
    headers: [
      { text: '日報No', value: 'nippoNo' },
      { text: '日報日', value: 'nippoYmd', align: 'center' },
      { text: '営業所', value: 'eigyoshoCdNm' },
      { text: '乗務員', value: 'jomuinCdNm' },
      { text: '助手', value: 'joshuCdNm' },
      { text: '車両番号', value: 'sharyoNoNm' },
      { text: '出庫日', value: 'shukkoYmd' },
      { text: '出庫時間', value: 'shukkoHms' },
      { text: '傭車先', value: 'hacchusakiCdNm' },
      { text: '貨物紐付け', value: 'bindCondition' }
    ],
    page: 1
  }),
  created () {
    console.log('screen created')
    this.$store.dispatch('system/setViewTitle', '受注検索')
    this.eigyoshoHeader = header.mstEigyoshoHeaders
    this.torihikisakiHeader = header.mstTorihikisakiHeaders
    this.syaryoHeader = header.vwCMstSharyoHeaders
    this.jininHeader = header.mstJininHeaders
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      jininList: 'DDMasters/mstJinin',
      sharyoList: 'DDMasters/vwCMstSharyo',
      torihikisakiList: 'DDMasters/mstTorihikisaki'
    }),
    filteredEigyoshoList () {
      return this.eigyoshoList
    },
    filteredTorihikisakiList () {
      return this.torihikisakiList
    },
    filteredJininList () {
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + ' ' + elem.jininNmMei
        return elem
      })
    },
    filteredMstSharyo () {
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstSharyoList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstSharyo.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      })
    },
    filteredRows () {
      return this.rows.map((elem) => {
        elem.nippoNo = elem.unkoJissekiNo
        elem.nippoYmd = filter.dateFormatter(elem.unkoYmd) ?? ''
        if (elem.eigyoshoCd) {
          elem.eigyoshoCdNm = elem.eigyoshoCd + ' ' + elem.eigyoshoNm
        }
        if (elem.haishaKbn === '01') {
          if (elem.sharyoCd) {
            elem.sharyoNoNm = elem.sharyoCd + ' ' + elem.sharyoNumber
          }
        } else {
          if (elem.hacchusakiShaban) {
            elem.sharyoNoNm = elem.hacchusakiShaban + ' ' + this.getSharyoNm(elem.hacchusakiShaban)
          }
        }
        if (elem.haishaKbn === '01') {
          if (elem.jomuinCd) {
            elem.jomuinCdNm = elem.jomuinCd + ' ' + elem.jomuinNm
          }
        } else {
          if (elem.hacchusakiJomuinCd) {
            elem.jomuinCdNm = elem.hacchusakiJomuinCd + ' ' + elem.hacchusakiJomuinNm
          }
        }
        if (elem.haishaKbn === '01') {
          if (elem.dojoshaCd) {
            elem.joshuCdNm = elem.dojoshaCd + ' ' + elem.dojoshaNm
          }
        }
        if (elem.hacchusakiCd) {
          elem.hacchusakiCdNm = elem.hacchusakiCd + ' ' + elem.hacchusakiNm
        }
        if (elem.shukkoYmd) {
          elem.shukkoYmd = filter.dateFormatter(elem.shukkoYmd) ?? ''
        }
        if (elem.shukkoHms) {
          elem.shukkoHms = this.convertFormatToHHMM(elem.shukkoHms)
        }
        if (elem.sagyoJissekiSagyoReleationId) {
          elem.bindCondition = '有'
        } else {
          elem.bindCondition = '無'
        }
        return elem
      })
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '85%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isSelectButtonDisabled () {
      return this.selectedItem.length === 0
    },
    calcHeightTable () {
      if (this.expansionPanel.length === 1) {
        return this.tableHeight * 0.46
      }
      return this.tableHeight * 0.29
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const opt = {
        loadMasters: ['mstjinin', 'msttorihikisaki', 'msteigyosho', 'vwcmstsharyo'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('ThNippoNoSearchDialog.defineHeaderPromise')
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          this.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          console.log('savedInputRestorePromise')
          // ユーザ保存項目の復元
          var kamotsuTaishoFlg = c.nippoKamotsuTaishoFlg !== 'false'
          this.conditions.Eigyosho = c.nippoEigyosho !== undefined && c.nippoEigyosho !== '' && c.nippoEigyosho !== null ? c.nippoEigyosho : ''
          this.conditions.nippoSbt = c.nippoNippoSbt !== undefined && c.nippoNippoSbt !== '' && c.nippoNippoSbt !== null ? c.nippoNippoSbt : '99'
          this.conditions.kamotsuTaishoFlg = kamotsuTaishoFlg
          this.conditions.jomuin = c.nippoJomuin !== undefined && c.nippoJomuin !== '' && c.nippoJomuin !== null ? c.nippoJomuin : ''
          this.conditions.sharyo = c.nippoSharyo !== undefined && c.nippoSharyo !== '' && c.nippoSharyo !== null ? c.nippoSharyo : ''
          this.conditions.tokuisakiCd = c.nippoTokuisakiCd !== undefined && c.nippoTokuisakiCd !== '' && c.nippoTokuisakiCd !== null ? c.nippoTokuisakiCd : ''
          this.onChangeNippoSbt()
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('ThNippoNoSearchDialog.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('ThNippoNoSearchDialog.researchPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.onSearchButtonClick()
            // this.search().then(() => {
            //   resolve()
            // })
          })
        },
        settingViewScroll: () => {
          return true
        },
        restoreViewPromise: (c) => {
          console.log('ThNippoNoSearchDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('ThNippoNoSearchDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        getCloneTargetMethod: function () {
          return {
            conditions: this.conditions
          }
        },
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForViewer(opt)
    },
    onChangeNippoSbt: function () {
      if (this.conditions.nippoSbt === '03') {
        const d = new Date()
        var biginningMonth = date.getFirstDate(d.getFullYear(), d.getMonth() + 1)
        this.conditions.nippoYmdFrom = biginningMonth
        this.conditions.nippoYmdTo = biginningMonth
      } else {
        this.conditions.nippoYmdFrom = this.hatsuchiYmd
        this.conditions.nippoYmdTo = this.hatsuchiYmd
      }
    },
    onRowDoubleClick: function (e, f) {
      /**
       * 選択時クローズ処理
       * @event doubleClick
       * @type {Event}
       */
      console.log('row double clicked', e)
      console.log('row double clicked', f)
      this.$emit('close', f.item)
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
      // this.clear(false)
    },
    onRowClick: function (e) {
      /**
       * 選択処理
       * @event Click
       * @type {Event}
       */
      console.log('row clicked', e, this.searchText)
      this.selectedItem = [e]
      /*
      if (this.selectedItem.length === 0) {
        this.selectedItem = [e]
      } else {
        this.selectedItem = []
      }
      */
    },
    onSelectButtonClick: function (e) {
      /**
       * 選択ボタン押下処理
       * @event click
       * @type {Event}
       */
      console.log('select clicked', e, this.selectedItem)
      if (this.selectedItem.length === 0) {
        this.$emit('close', undefined)
      } else {
        this.$emit('close', this.selectedItem[0])
      }
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
      // this.clear(false)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VWCTHPRMD00100/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChacheById('THPRMD0010', cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            nippoEigyosho: self.conditions.Eigyosho ? self.conditions.Eigyosho : '',
            nippoNippoSbt: self.conditions.nippoSbt,
            nippoKamotsuTaishoFlg: self.conditions.kamotsuTaishoFlg,
            nippoJomuin: self.conditions.jomuin ? self.conditions.jomuin : '',
            nippoSharyo: self.conditions.sharyo ? self.conditions.sharyo : '',
            nippoTokuisakiCd: self.conditions.tokuisakiCd ? self.conditions.tokuisakiCd : ''
          }
        }
      }
      this.search(opt)
    },
    clear: function (isRemainRows) {
      console.log('clear', this.torihikisakiList)
      return new Promise(resolve => {
        this.initBindVariables()
        if (!isRemainRows) {
          this.rows = []
          this.searchText = ''
          this.selectedItem = []
        }
        resolve()
      })
    },
    clearExec: function () {
      console.log('NewButton pushed')
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
        this.conditions.nippoYmdFrom = ''
        this.conditions.nippoYmdTo = ''
        this.searchText = ''
        this.rows = []
        this.selectedItem = []
      })
      this.Effects.loadComplete()
    },
    onClearButtonClick: function (e) {
      /**
       * クリアボタン押下処理
       * @event click
       * @type {Event}
       */
      this.Effects.loadStart()
      this.clearExec()
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
      this.$emit('close', undefined)
      console.log('emited', this.showDialog)
      // this.clear(false)
    },
    searchValidate: function () {
      var msg
      if (this.conditions.nippoYmdFrom && this.conditions.nippoYmdTo) {
        msg = validators.compareDate(this.conditions.nippoYmdFrom, this.conditions.nippoYmdTo)
        if (msg !== undefined) {
          this.$refs.nippoYmdFrom[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.nippoYmdTo[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.conditions = {
        nippoYmdFrom: this.hatsuchiYmd,
        nippoYmdTo: this.hatsuchiYmd,
        Eigyosho: '',
        nippoSbt: '99',
        kamotsuTaishoFlg: true,
        jomuin: '',
        sharyo: '',
        tokuisakiCd: ''
      }
    },
    getSharyoNm: function (sharyoNo) {
      var sharyo = this.sharyoList.filter((t) => {
        return t.sharyoNo === sharyoNo
      })
      if (sharyo.length > 0) {
        return sharyo[0].jidoshaHyojiNm
      } else {
        return ''
      }
    },
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    // * 別途共通関数待
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    convertFormatToHHMM: function (val) {
      if (val.length < 5) return val
      return val.substr(0, 5)
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 400 !important;
}
</style>
